import { useEffect, useRef } from 'react'

const WaveResonance = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    let animationFrameId: number
    let time = 0
    const amplitude = 50
    const baseFreq1 = 0.02
    const baseFreq2 = 0.03

    function drawWave() {
      if (!canvas || !ctx) return

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      
      const harmonyProgress = (Math.sin(time / 200) + 1) / 2
      
      const freq1 = baseFreq1 * (1 - harmonyProgress) + 0.025 * harmonyProgress
      const freq2 = baseFreq2 * (1 - harmonyProgress) + 0.025 * harmonyProgress
      
      // Draw first wave (darker black)
      ctx.beginPath()
      ctx.strokeStyle = 'rgba(0, 0, 0, 0.9)'
      ctx.lineWidth = 3
      
      for (let x = 0; x < canvas.width; x++) {
        const y = amplitude * Math.sin(x * freq1 + time / 20) + canvas.height / 2
        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y)
      }
      ctx.stroke()
      
      // Draw second wave (lighter grey)
      ctx.beginPath()
      ctx.strokeStyle = 'rgba(160, 160, 160, 0.7)'
      ctx.lineWidth = 3
      
      for (let x = 0; x < canvas.width; x++) {
        const y = amplitude * Math.sin(x * freq2 + time / 15) + canvas.height / 2
        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y)
      }
      ctx.stroke()
      
      // Draw resonance indicator
      if (harmonyProgress > 0.8) {
        ctx.fillStyle = `rgba(0, 0, 0, ${(harmonyProgress - 0.8) * 5})`
        ctx.font = '14px system-ui'
        ctx.textAlign = 'center'
        ctx.fillText('Harmonics Achieved!', canvas.width / 2, 30)
      }
      
      time++
      animationFrameId = requestAnimationFrame(drawWave)
    }

    drawWave()

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId)
      }
    }
  }, [])

  return (
    <div className="w-full h-[300px] border border-foreground/10 rounded-xl bg-transparent shadow-sm p-5 box-border">
      <div className="flex justify-center items-center h-full w-full overflow-hidden">
        <canvas
          ref={canvasRef}
          width={800}
          height={300}
          className="border-l-2 border-foreground/10 bg-gradient-to-b from-transparent via-foreground/10 to-transparent bg-[length:1px_2px] bg-center bg-repeat-y"
        />
      </div>
    </div>
  )
}

export default WaveResonance 